export enum KeyCode {
  A = 'KeyA',
  AltLeft = 'AltLeft',
  AltRight = 'AltRight',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  B = 'KeyB',
  Backquote = 'Backquote',
  Backslash = 'Backslash',
  Backspace = 'Backspace',
  BracketLeft = 'BracketLeft',
  BracketRight = 'BracketRight',
  C = 'KeyC',
  CapsLock = 'CapsLock',
  Comma = 'Comma',
  ControlLeft = 'ControlLeft',
  ControlRight = 'ControlRight',
  D = 'KeyD',
  Delete = 'Delete',
  E = 'KeyE',
  Eight = 'Digit8',
  End = 'End',
  Enter = 'Enter',
  Equal = 'Equal',
  Escape = 'Escape',
  F = 'KeyF',
  F1 = 'F1',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  Five = 'Digit5',
  Four = 'Digit4',
  G = 'KeyG',
  H = 'KeyH',
  Home = 'Home',
  I = 'KeyI',
  Insert = 'Insert',
  IntlBackslash = 'IntlBackslash',
  J = 'KeyJ',
  K = 'KeyK',
  L = 'KeyL',
  M = 'KeyM',
  MetaLeft = 'MetaLeft',
  MetaRight = 'MetaRight',
  Minus = 'Minus',
  N = 'KeyN',
  Nine = 'Digit9',
  NumLock = 'NumLock',
  Numpad0 = 'Numpad0',
  Numpad1 = 'Numpad1',
  Numpad2 = 'Numpad2',
  Numpad3 = 'Numpad3',
  Numpad4 = 'Numpad4',
  Numpad5 = 'Numpad5',
  Numpad6 = 'Numpad6',
  Numpad7 = 'Numpad7',
  Numpad8 = 'Numpad8',
  Numpad9 = 'Numpad9',
  NumpadAdd = 'NumpadAdd',
  NumpadComma = 'NumpadComma',
  NumpadDecimal = 'NumpadDecimal',
  NumpadDivide = 'NumpadDivide',
  NumpadEnter = 'NumpadEnter',
  NumpadEqual = 'NumpadEqual',
  NumpadMultiply = 'NumpadMultiply',
  NumpadSubtract = 'NumpadSubtract',
  O = 'KeyO',
  One = 'Digit1',
  P = 'KeyP',
  PageDown = 'PageDown',
  PageUp = 'PageUp',
  PauseBreak = 'PauseBreak',
  Period = 'Period',
  Q = 'KeyQ',
  Quote = 'Quote',
  R = 'KeyR',
  S = 'KeyS',
  ScrollLock = 'ScrollLock',
  SemiColon = 'SemiColon',
  Semicolon = 'Semicolon',
  Seven = 'Digit7',
  ShiftLeft = 'ShiftLeft',
  ShiftRight = 'ShiftRight',
  Six = 'Digit6',
  Slash = 'Slash',
  Space = 'Space',
  T = 'KeyT',
  TAB = 'Tab',
  Three = 'Digit3',
  Two = 'Digit2',
  U = 'KeyU',
  V = 'KeyV',
  W = 'KeyW',
  X = 'KeyX',
  Y = 'KeyY',
  Z = 'KeyZ',
  Zero = 'Digit0'
}
